var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { P as PassportClients, C as COMMON_QUERY_STALE_TIME, u as useDataDogActionTracking } from "./common-B_iPBwyX.js";
import { q as queryOptions, s as getCircumferenceMeasurements, v as getProductMeasurementsAndAdjustments, w as getProductMeasurements, x as getFitMeasurements, u as useQuery } from "./public-get.api-BzvvLLiu.js";
import { useRef, useEffect } from "react";
var RtwInCompatibilityReasonCode = /* @__PURE__ */ ((RtwInCompatibilityReasonCode2) => {
  RtwInCompatibilityReasonCode2["AlterationOutOfRange"] = "AlterationOutOfRange";
  RtwInCompatibilityReasonCode2["SizeDoesNotMatch"] = "SizeDoesNotMatch";
  RtwInCompatibilityReasonCode2["FitBucketDoesntMatch"] = "FitBucketDoesntMatch";
  RtwInCompatibilityReasonCode2["FitUpdated"] = "FitUpdated";
  RtwInCompatibilityReasonCode2["FabricLimitation"] = "FabricLimitation";
  RtwInCompatibilityReasonCode2["SizeIsNotRecognized"] = "SizeIsNotRecognized";
  return RtwInCompatibilityReasonCode2;
})(RtwInCompatibilityReasonCode || {});
var SizePassportScoreCode = /* @__PURE__ */ ((SizePassportScoreCode2) => {
  SizePassportScoreCode2["RISK"] = "Risk";
  SizePassportScoreCode2["WARNING"] = "Warning";
  SizePassportScoreCode2["SAFE"] = "Safe";
  return SizePassportScoreCode2;
})(SizePassportScoreCode || {});
var SizePassportScoreCodePriority = /* @__PURE__ */ ((SizePassportScoreCodePriority2) => {
  SizePassportScoreCodePriority2[SizePassportScoreCodePriority2["Safe"] = 2] = "Safe";
  SizePassportScoreCodePriority2[SizePassportScoreCodePriority2["Warning"] = 1] = "Warning";
  SizePassportScoreCodePriority2[SizePassportScoreCodePriority2["Missing"] = 0] = "Missing";
  SizePassportScoreCodePriority2[SizePassportScoreCodePriority2["Risk"] = -1] = "Risk";
  return SizePassportScoreCodePriority2;
})(SizePassportScoreCodePriority || {});
const getSizePassportSource = (client) => {
  const clientValue = PassportClients[client];
  if (!clientValue) {
    throw Error("getSizePassportSource: Size Passport Source is not fitting existing values");
  }
  return clientValue;
};
const isClientOffline = (client) => {
  if (!client) {
    throw new Error("isCustomerOffline: client is not defined!");
  }
  return client === PassportClients.SuitsupplyCM || client === PassportClients.SuitsupplyRTW || client === PassportClients.SuitsupplyRealt;
};
const isRTWOfflineClient = (client) => {
  if (!client) {
    throw new Error("isRTWCustomer: client is not defined!");
  }
  return client === PassportClients.SuitsupplyRTW || client === PassportClients.SuitsupplyRealt;
};
const isCMOnlineClient = (client) => {
  if (!client) {
    throw new Error("isCMOnlineCustomer: client is not defined!");
  }
  return client === PassportClients.CustomerCM;
};
const isCMOfflineClient = (client) => {
  if (!client) {
    throw new Error("isCMOfflineCustomer: client is not defined!");
  }
  return client === PassportClients.SuitsupplyCM;
};
const isCMClient = (client) => {
  if (!client) {
    throw new Error("isCMCustomer: client is not defined!");
  }
  return client === PassportClients.CustomerCM || client === PassportClients.SuitsupplyCM;
};
const multiplyMeasurementNumber = (value, accuracy = 5, fixedDigits = 2) => {
  const newValue = value * accuracy * 2 / accuracy;
  return Number(newValue.toFixed(fixedDigits));
};
const divideMeasurementNumber = (value, accuracy = 5, fixedDigits = 2) => {
  const newValue = value * accuracy / (accuracy * 2);
  return Number(newValue.toFixed(fixedDigits));
};
const isMeasurementIdIncluded = (searchList, id) => searchList.includes(id);
const mapObjectProps = (originalObj, valueMapper, multiplyValues = true, multiplyKeys = false) => {
  const keys = Object.keys(originalObj);
  if (keys.length === 0) {
    return {};
  }
  let updatedObj = {};
  keys.forEach((key) => {
    const newKey = multiplyKeys ? `${valueMapper(Number(key))}` : key;
    updatedObj[newKey] = multiplyValues ? valueMapper(originalObj[key]) : originalObj[key];
  });
  return updatedObj;
};
const multiplyInfluencesMap = (measurementIds, measurementItem, mapKey) => {
  const mapItem = measurementItem[mapKey];
  const keys = Object.keys(mapItem);
  if (keys.length === 0) {
    return {};
  }
  const shouldMultiplyKeys = isMeasurementIdIncluded(measurementIds, measurementItem.id);
  let updatedMap = {};
  keys.forEach((key) => {
    const shouldMultiplyValues = isMeasurementIdIncluded(measurementIds, key);
    updatedMap[key] = mapObjectProps(mapItem[key], multiplyMeasurementNumber, shouldMultiplyValues, shouldMultiplyKeys);
  });
  return updatedMap;
};
const multiplyDynamicInfluencesMap = (measurementIds, measurementItem) => {
  const dynamicMap = measurementItem.dynamicInfluenceMeasurementsRtw;
  const shouldMultiplySourceKeys = isMeasurementIdIncluded(measurementIds, measurementItem.id);
  const result = {};
  for (const [targetId, valueRelations] of Object.entries(dynamicMap)) {
    const shouldMultiplyTargetValues = isMeasurementIdIncluded(measurementIds, targetId);
    const updatedRelations = {};
    const entries = Object.entries(valueRelations);
    for (const [groupKey, allowedValues] of entries) {
      let newKey = groupKey;
      if (shouldMultiplySourceKeys) {
        try {
          const group = JSON.parse(groupKey);
          newKey = JSON.stringify(group.map((v) => multiplyMeasurementNumber(v)));
        } catch (e) {
        }
      }
      updatedRelations[newKey] = shouldMultiplyTargetValues ? allowedValues.map((v) => multiplyMeasurementNumber(v)) : allowedValues;
    }
    result[targetId] = updatedRelations;
  }
  return result;
};
const divideMatchingMeasurementsValues = (measurementIds, originalMeasurementsList) => {
  return originalMeasurementsList.map((measurement) => {
    const isIncluded = isMeasurementIdIncluded(measurementIds, measurement.measurementId);
    return __spreadProps(__spreadValues({}, measurement), {
      value: isIncluded ? divideMeasurementNumber(measurement.value) : measurement.value
    });
  });
};
const multiplyExtendedMeasurements = (measurementIds, measurementValues) => {
  if (!measurementValues) return measurementValues;
  return measurementValues.map((measurement) => {
    const isIncluded = isMeasurementIdIncluded(measurementIds, measurement.measurementId);
    return __spreadProps(__spreadValues({}, measurement), {
      value: isIncluded ? multiplyMeasurementNumber(measurement.value) : measurement.value,
      defaultValue: isIncluded ? multiplyMeasurementNumber(measurement.defaultValue) : measurement.defaultValue,
      alterationValue: isIncluded ? multiplyMeasurementNumber(measurement.alterationValue) : measurement.alterationValue
    });
  });
};
const multiplyDefaultMeasurement = (measurementIds, measurementItem) => {
  const isIncluded = isMeasurementIdIncluded(measurementIds, measurementItem.measurementId);
  return isIncluded ? __spreadProps(__spreadValues({}, measurementItem), {
    value: multiplyMeasurementNumber(measurementItem.value)
  }) : measurementItem;
};
const multiplyTailorAlterationsValues = (measurementIds, alterations) => {
  return alterations.map((alteration) => {
    const isIncluded = isMeasurementIdIncluded(measurementIds, alteration.measurementId);
    return __spreadProps(__spreadValues({}, alteration), {
      alterationValue: isIncluded ? multiplyMeasurementNumber(alteration.alterationValue) : alteration.alterationValue,
      absoluteValue: isIncluded && alteration.absoluteValue != null ? multiplyMeasurementNumber(alteration.absoluteValue) : alteration.absoluteValue
    });
  });
};
const multiplyMeasurementDefinitionValues = (measurementIds, measurementItem) => {
  const newMeasurementItem = __spreadProps(__spreadValues({}, measurementItem), {
    forcedInfluenceMeasurements: measurementItem.forcedInfluenceMeasurements ? multiplyInfluencesMap(measurementIds, measurementItem, "forcedInfluenceMeasurements") : measurementItem.forcedInfluenceMeasurements,
    forcedInfluenceMeasurementsRtw: measurementItem.forcedInfluenceMeasurementsRtw ? multiplyInfluencesMap(measurementIds, measurementItem, "forcedInfluenceMeasurementsRtw") : measurementItem.forcedInfluenceMeasurementsRtw,
    dynamicInfluenceMeasurementsRtw: measurementItem.dynamicInfluenceMeasurementsRtw ? multiplyDynamicInfluencesMap(measurementIds, measurementItem) : measurementItem.dynamicInfluenceMeasurementsRtw
  });
  const isIncluded = isMeasurementIdIncluded(measurementIds, measurementItem.id);
  if (!isIncluded) {
    return newMeasurementItem;
  }
  switch (newMeasurementItem.type) {
    case "Range":
      return multiplyRangeValues(newMeasurementItem);
    case "Choice":
      return multiplyChoiceValues(newMeasurementItem);
  }
};
const multiplyRangeValues = (measurementItem) => {
  const mappedAlterationDetails = measurementItem.alterationDetails ? mapObjectProps(measurementItem.alterationDetails, multiplyMeasurementNumber) : measurementItem.alterationDetails;
  const mappedDetails = measurementItem.details ? mapObjectProps(measurementItem.details, multiplyMeasurementNumber) : measurementItem.details;
  return __spreadProps(__spreadValues({}, measurementItem), {
    alterationDetails: mappedAlterationDetails,
    details: mappedDetails
  });
};
const multiplyChoiceValues = (measurementItem) => {
  const mappedAlterationDetails = measurementItem.alterationDetails ? multiplyChoiceDetailValues(measurementItem.alterationDetails) : measurementItem.alterationDetails;
  const mappedDetails = measurementItem.details ? multiplyChoiceDetailValues(measurementItem.details) : measurementItem.details;
  return __spreadProps(__spreadValues({}, measurementItem), {
    alterationDetails: mappedAlterationDetails,
    details: mappedDetails
  });
};
const multiplyChoiceDetailValues = (details) => {
  return {
    values: details.values.map((item) => __spreadProps(__spreadValues({}, item), {
      value: multiplyMeasurementNumber(item.value)
    }))
  };
};
const dividePassportMeasurementsBeforeCreation = (measurementIds, measurementsList) => {
  return divideMatchingMeasurementsValues(measurementIds, measurementsList);
};
const multiplyProfileMeasurements = (measurementIds, payload) => {
  const updatedMeasurements = multiplyExtendedMeasurements(measurementIds, payload.sizePassport.measurementValues);
  return __spreadProps(__spreadValues({}, payload), {
    sizePassport: __spreadProps(__spreadValues({}, payload.sizePassport), {
      measurementValues: updatedMeasurements
    })
  });
};
const multiplyProfilesMeasurements = (measurementIds, payload) => {
  const mappedProfiles = payload.profiles.length > 0 ? payload.profiles.map((profile) => multiplyProfileMeasurements(measurementIds, profile)) : [];
  return __spreadProps(__spreadValues({}, payload), {
    profiles: mappedProfiles
  });
};
const multiplyProductProfilesMeasurements = (measurementIds, payload) => {
  return (payload == null ? void 0 : payload.length) ? payload.map((profile) => multiplyProfileMeasurements(measurementIds, profile)) : [];
};
const multiplyMeasurementsInDefinitions = (measurementIds, payload) => {
  return payload.map((definition) => multiplyMeasurementDefinitionValues(measurementIds, definition));
};
const multiplyFitMeasurements = (measurementIds, payload) => {
  return payload.map((measurement) => multiplyDefaultMeasurement(measurementIds, measurement));
};
const multiplyTailorAlterations = (measurementIds, payload) => {
  if (!payload.alterations) {
    return payload;
  }
  const mappedAlterations = multiplyTailorAlterationsValues(measurementIds, payload.alterations);
  return __spreadProps(__spreadValues({}, payload), {
    alterations: mappedAlterations
  });
};
const queryCircumferenceMeasurements = ({
  isEnabled = true,
  productType
}) => {
  return queryOptions({
    enabled: isEnabled,
    queryKey: ["circumferenceMeasurements", productType],
    queryFn: () => __async(null, null, function* () {
      return yield getCircumferenceMeasurements(productType);
    }),
    staleTime: COMMON_QUERY_STALE_TIME
  });
};
const queryProductMeasurementsDefinitions = ({
  isEnabled = true,
  config
}) => {
  return queryOptions({
    enabled: isEnabled,
    queryKey: ["productMeasurementsDefinitions", config],
    queryFn: () => __async(null, null, function* () {
      return yield getProductMeasurements(config);
    }),
    staleTime: COMMON_QUERY_STALE_TIME
  });
};
const queryProductMeasurementsAndAdjustmentsDefinitions = ({
  isEnabled = true,
  config
}) => {
  return queryOptions({
    enabled: isEnabled,
    queryKey: ["productMeasurementsAndAdjustmentsDefinitions", config],
    queryFn: () => __async(null, null, function* () {
      return yield getProductMeasurementsAndAdjustments(config);
    }),
    staleTime: COMMON_QUERY_STALE_TIME
  });
};
const queryBaseMeasurements = ({
  isEnabled = true,
  config
}) => {
  return queryOptions({
    enabled: isEnabled,
    queryKey: ["productBaseMeasurements", config],
    queryFn: () => __async(null, null, function* () {
      return yield getFitMeasurements(config);
    }),
    staleTime: COMMON_QUERY_STALE_TIME
  });
};
function useCircumferenceMeasurementsQuery({
  isEnabled,
  isAllowed,
  productType
}) {
  const mockedResponse = useRef({
    isLoading: false,
    isSuccess: true,
    error: null,
    data: [],
    retry: () => {
    }
  });
  const {
    trackAction
  } = useDataDogActionTracking();
  const {
    isLoading,
    isSuccess,
    data,
    error,
    refetch
  } = useQuery(queryCircumferenceMeasurements({
    isEnabled: isEnabled && isAllowed && !!productType,
    productType
  }));
  useEffect(() => {
    if (error) {
      trackAction({
        eventName: "meas-circumference-measurements-failure",
        eventDetails: {
          errorDetails: error,
          productTypeId: productType
        },
        eventType: "error"
      });
    }
  }, [error, trackAction, productType]);
  if (!isAllowed) {
    return mockedResponse.current;
  }
  const handleRetry = () => {
    void refetch({});
  };
  return {
    isLoading,
    isSuccess,
    error,
    data: data || [],
    retry: handleRetry
  };
}
export {
  RtwInCompatibilityReasonCode as R,
  SizePassportScoreCode as S,
  isRTWOfflineClient as a,
  SizePassportScoreCodePriority as b,
  isClientOffline as c,
  multiplyProductProfilesMeasurements as d,
  isCMOfflineClient as e,
  isCMOnlineClient as f,
  queryProductMeasurementsAndAdjustmentsDefinitions as g,
  multiplyMeasurementsInDefinitions as h,
  isCMClient as i,
  queryCircumferenceMeasurements as j,
  multiplyProfileMeasurements as k,
  multiplyTailorAlterations as l,
  multiplyProfilesMeasurements as m,
  dividePassportMeasurementsBeforeCreation as n,
  multiplyFitMeasurements as o,
  queryBaseMeasurements as p,
  queryProductMeasurementsDefinitions as q,
  getSizePassportSource as r,
  useCircumferenceMeasurementsQuery as u
};
